module.exports = __webpack_public_path__ + "static/Prof Asha Hingar-694045037148b6c33578cf4591f24093.jpg";